import { render, staticRenderFns } from "./NationalPatentAuthority.vue?vue&type=template&id=520f0f02&"
import script from "./NationalPatentAuthority.vue?vue&type=script&lang=js&"
export * from "./NationalPatentAuthority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports